<template>
    <div class="row">
            <div class="text-center">
                <img class="icon-lg" src="../../assets/icons/ic_timelapse.svg" alt="timelapse"/>
                <div class="mt-2">{{title}}</div>

                <div class="mt-3">
                <button class="btn btn-tan">BLOCK EXPLORER</button>
                </div>
            </div>
    </div>
</template>

<script>
    export default {
        name: 'Spinner',
        props: ['title']
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
